import { useState, useContext } from 'react'
import { AdminContext } from 'context/AdminContext'

import UserDirectoryUserInfoTableHeader from 'components/UserDirectory/UserDirectoryUserInfoTableHeader'
import UserDirectoryUserInfoRow from 'components/UserDirectory/UserDirectoryUserInfoRow'
import OutlineButton from 'components/Buttons/OutlineButton'

export default function SelectedUserDirectoryUser() {

    const { UserDirectorySubContext } = useContext(AdminContext)

    const [showCopyToast, setShowCopyToast] = useState(false)
    const [copyToastText, setCopyToastText] = useState('')

    const OnEmailCopyButtonClicked = (email) => {
        navigator.clipboard.writeText(email)
        setCopyToastText(email)
        setShowCopyToast(true)
        setTimeout(() => setShowCopyToast(false), 2000)
    }

    const ShowSwapAuth0AccountButton = () => {
        const athleteCount = UserDirectorySubContext.selectedUserDirectoryUsers.filter((selectedUser) => selectedUser.type === 'trainee').length
        const coachCount = UserDirectorySubContext.selectedUserDirectoryUsers.filter((selectedUser) => ['organization-owner', 'organization-admin', 'trainer'].includes(selectedUser.type)).length

        if (
            UserDirectorySubContext.selectedUserDirectoryUsers.length === 2
            && athleteCount === 1
            && coachCount === 1
            && UserDirectorySubContext.selectedUserDirectoryUsers.every((selectedUser) => selectedUser.auth0UserId.length > 0)
            && UserDirectorySubContext.selectedUserDirectoryUsers.every((selectedUser) => selectedUser.auth0UserId.startsWith('apple') === false
        )
        ) {
            return true
        }

        return false
    }

    if (UserDirectorySubContext.selectedUserDirectoryUsers.length === 0) {
        return null
    }

    return (
        <div className="space-y-2">
            <h2 className="text-lg font-semibold text-gray-900">
                Selected users ({UserDirectorySubContext.selectedUserDirectoryUsers.length})
            </h2>

            {showCopyToast && (
                <div className="fixed bottom-4 right-4 bg-gray-800 text-white px-4 py-2 rounded-md shadow-lg z-50 animate-fade-in-out">
                    Copied "{copyToastText}" to clipboard
                </div>
            )}

            <div className="text-sm border-x border-t border-gray-400 divide-y divide-gray-400 rounded overflow-hidden bg-white w-full min-w-0">
                <div className="overflow-x-auto w-full min-w-0">
                    <UserDirectoryUserInfoTableHeader />

                    {UserDirectorySubContext.selectedUserDirectoryUsers.map((user, index) => (
                        <UserDirectoryUserInfoRow
                            key={index}
                            user={user}
                            isSelected={true}
                            OnEmailCopyButtonClicked={OnEmailCopyButtonClicked}
                            UserDirectorySubContext={UserDirectorySubContext}
                        />
                    ))}
                </div>
            </div>

            {ShowSwapAuth0AccountButton() && (
                <div className="flex justify-end">
                    <div className='w-40'>
                        <OutlineButton
                            size="extra-small"
                            text="Swap Auth0 Accounts"
                            action={() => UserDirectorySubContext.ShowSwapAuth0AccountModal()}
                        />
                    </div>
                </div>
            )}
        </div>
    )
}
